import loggingService from '../services/util/loggingService'

var serviceName = 'paymentService'
var path = '/Payment/'
var isDebug = false

const PaymentTypeEnum = {
    FileSearch: 1
}

function getPaymentConfig (http) {
    loggingService.log(isDebug, serviceName, 'Getting Config')
    return http.get(path + 'PaymentConfig')
}

// function saveTransactionReceipt (http, transactionReceipt) {
//     return http.put(path + 'TransactionReceipt', transactionReceipt)
// }

function getBillingCodeByFileSearch (http, fileSearchId) {
    return http.get(path + 'BillingCodeByFileSearch?fileSearchId=' + fileSearchId)
}

function getTransactionReceipt (http, paymentTypeId, parentId) {
    return http.get(path + `GetTransactionReceipt?paymentType=${paymentTypeId}&parentId=${parentId}`)
}

function paymentReceiptReportGen (http, paymentTypeId, parentId) {
    return http.get(path + `PaymentReceiptReportGen?paymentType=${paymentTypeId}&parentId=${parentId}`, { responseType: 'arraybuffer' })
}

function getSquareCheckout (http, parentId, paymentTypeId, domain) {
    return http.get(path + `GetSquareCheckout?parentId=${parentId}&paymentType=${paymentTypeId}&clientDomain=${domain}`)
}

function getMockSquareCheckout (http, parentId, paymentTypeId, domain) {
    return http.get(path + `GetMockSquareCheckout?parentId=${parentId}&paymentType=${paymentTypeId}&clientDomain=${domain}`)
}

function completeSquareTransaction (http, paymentTypeId, transactionId, checkoutId) {
    return http.get(path + `CompleteSquareTransaction?paymentType=${paymentTypeId}&transactionId=${transactionId}&checkoutId=${checkoutId}`)
}

export default {
    PaymentTypeEnum: PaymentTypeEnum,
    getPaymentConfig: getPaymentConfig,
    //saveTransactionReceipt: saveTransactionReceipt,
    getBillingCodeByFileSearch: getBillingCodeByFileSearch,
    getTransactionReceipt: getTransactionReceipt,
    paymentReceiptReportGen: paymentReceiptReportGen,
    getSquareCheckout: getSquareCheckout,
    getMockSquareCheckout: getMockSquareCheckout,
    completeSquareTransaction: completeSquareTransaction
}



// WEBPACK FOOTER //
// ./src/services/paymentService.js